import React, { useEffect, useState } from 'react'
import SalesChannelTypeForm from '../../components/Forms/SalesChannelType/SalesChannelTypeForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { useSalesChannelType } from '../../hooks/CompanyConfiguration/useSalesChannelType'
import { ROUTES } from '../../shared/constants'
import {useParams} from 'react-router-dom'
export default function AddSalesChannelType() {
  const { addSalesChannelType, updateSalesChannelType, salesChannelType, getSalesChannelType } = useSalesChannelType()
  const [salesChannelTypeForm, setSalesChannelTypeForm] = useState({
    channelType: '',
    name: '',
    email: '',
    address: '', 
    contact: '', 
    companyName: '',
    remarks: '',
    // category: '',
    // subCategory: '',
    shopImg: '',
    businessCardImg: '',
  })
  const param = useParams()
  const handleAddSalesChannelType = () => {
    if (salesChannelType) {
      updateSalesChannelType({
        salesChannelTypeId: salesChannelType._id,
        ...salesChannelTypeForm
      })
    } else {
      addSalesChannelType({
        ...salesChannelTypeForm
      })
    }
  }

  useEffect(() => {
    console.log(param)
    if(param.salesChannelTypeId!== undefined){
      getSalesChannelType({salesChannelTypeId: param.salesChannelTypeId})
    }
    console.log(salesChannelType)
    if (salesChannelType) {
      setSalesChannelTypeForm({
        ...salesChannelType,
        name: salesChannelType.name,
      })
    }
  }, [param, salesChannelType])

  return (
    <Layout
      heading="Sales Channel Type"
      heading2={salesChannelType ? 'Edit' : 'Add'}
      url1={ROUTES.SALES_CHANNEL_TYPE}
      none
    >
      <HeaderTabLayout
        heading={`${salesChannelType ? 'Edit' : 'Add'} Sales Channel Type`}
        content={<SalesChannelTypeForm form={salesChannelTypeForm} setForm={setSalesChannelTypeForm} />}
        addContent={handleAddSalesChannelType}
        redirect={ROUTES.SALES_CHANNEL_TYPE}
        state = {salesChannelTypeForm}
        setState = {setSalesChannelTypeForm}
      />
    </Layout>
  )
}
